import { GameBaseScene } from 'src/games/common/phaser/game/scenes/game-base-scene';
import { SolitaireApp } from '../solitaire-app';
import { SolitaireListener } from '../solitaire-listener';
import { SolitaireMainScene } from './solitaire-main-scene';

export class SolitairePreloadScene extends GameBaseScene {
  public static get className(): string {
    return SolitairePreloadScene.name;
  }

  constructor(private localAssetPath: string) {
    super(SolitairePreloadScene.className);
  }

  public setGameListener(gameListener: SolitaireListener) {
    SolitaireApp.getInstance().setSolitaireListener(gameListener);
  }

  public preload() {
    SolitaireApp.getInstance().preloadAssets(this, this.localAssetPath);
  }

  protected override onLoadProgress(progress: number) {
    super.onLoadProgress(progress);
  }

  protected override onLoadComplete() {
    super.onLoadComplete();

    this.scene.start(SolitaireMainScene.className);
  }
}
